import { ref, watch, computed } from 'vue';
import { createGlobalState } from '@vueuse/core';
import { useCompareUrlState } from '@/composables/use-compare-url-state';
import { useCompareInit } from '@/composables/use-compare-init';
import sleep from '@/utils/sleep';
import _ from 'lodash';

const ENABLED_COMPARE_WORDING_LANG = ['EN', 'CN'];

export const useCompareWording = createGlobalState(() => {
    const {
        compareId,
        leftId,
        rightId,
        leftPath,
        isSourcePatent,
    } = useCompareUrlState();
    const {
        compareInit,
        textCompareLang,
        compareLang,
        matchTextList,
    } = useCompareInit();

    const isCompareWordingStart = ref(false);
    const compareWordingTextList = ref<string[]>([]);
    const compareWordingParaNumMap = ref<{
        [key: string]: {
            uniqueId: string;
            path: string;
        };
    }>({});

    const compareWordingCacheKey = ref(1);

    const showWordingNotFoundBar = ref(false);

    const onShowWordingNotFoundBar = async () => {
        showWordingNotFoundBar.value = true;
        // 两秒后自动消失
        await sleep(2000);
        showWordingNotFoundBar.value = false;
    };

    const changeCompareWordingStart = (status) => {
        isCompareWordingStart.value = status;
    };

    const resetCompareWordingState = () => {
        compareWordingTextList.value = [];
        compareWordingParaNumMap.value = {};
        compareWordingCacheKey.value += 1;
    };

    const onCompareWording = async (text: string, uniqueId: string) => {
        compareWordingTextList.value.push(text);
        await compareInit({
            compare_id: compareId.value,
            target_patent_id: rightId.value,
            src_patent_id: leftId.value,
            text_compare_lang: textCompareLang.value,
            compare_lang: compareLang.value,
            tech_text_list: compareWordingTextList.value,
        });

        const curWordingMatchItem = _.find(matchTextList.value, item => {
            return item.text === text;
        });
        const curwordingParaNum = curWordingMatchItem?.partId;
        if (curwordingParaNum && uniqueId) {
            compareWordingParaNumMap.value[curwordingParaNum] = {
                uniqueId,
                path: leftPath.value,
            };
        }
        return curwordingParaNum;
    };

    watch(rightId, () => {
        resetCompareWordingState();
    });

    const enabledCompareWording = computed(() => {
        return _.includes(ENABLED_COMPARE_WORDING_LANG, compareLang.value) && isSourcePatent.value;
    });


    return {
        isCompareWordingStart,
        compareWordingParaNumMap,
        compareWordingCacheKey,
        enabledCompareWording,
        showWordingNotFoundBar,

        onCompareWording,
        onShowWordingNotFoundBar,
        changeCompareWordingStart,
        resetCompareWordingState,
    };
});
